import React from 'react';

const GameSidebar = ({
  players,
  currentPlayer,
  gameStatus,
  playerColor,
  playerId
}) => {
  const getPlayerByColor = (color) => {
    return Object.values(players).find(p => p.color === color);
  };

  const playerColors = ['red', 'blue', 'yellow', 'green'];

  return (
    <div className="game-sidebar">
      <div className="game-info">
        <h3>Game Status</h3>
        {gameStatus.isGameStarted ? (
          <div className="status-info">
            {gameStatus.isGameOver ? (
              <div className="game-over">
                🏆 Game Over!<br/>
                Winner: {gameStatus.winner}
              </div>
            ) : (
              <div className="game-active">
                🎮 Game Active<br/>
                {currentPlayer && `${currentPlayer.name}'s turn`}
              </div>
            )}
          </div>
        ) : (
          <div className="waiting">
            ⏳ Waiting for players...
          </div>
        )}
      </div>

      <div className="players-info">
        <h3>Players ({Object.keys(players).length}/4)</h3>
        <div className="players-list">
          {playerColors.map(color => {
            const player = getPlayerByColor(color);
            return (
              <div 
                key={color}
                className={`player-info ${player ? 'active' : 'empty'} ${
                  currentPlayer && player && currentPlayer.id === player.id ? 'current-turn' : ''
                } ${player && player.id === playerId ? 'own-player' : ''}`}
              >
                <div className={`player-color ${color}`}></div>
                <div className="player-details">
                  {player ? (
                    <>
                      <div className="player-name">
                        {player.name}
                        {player.id === playerId && ' (You)'}
                      </div>
                      <div className="player-pieces">
                        Pieces in home: {player.pieces ? player.pieces.filter(p => p.isInHome).length : 4}
                      </div>
                    </>
                  ) : (
                    <div className="waiting-slot">Waiting for player...</div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="game-rules">
        <h4>How to Play:</h4>
        <ul>
          <li>🎲 Roll 6 to start a piece</li>
          <li>🏃 Move pieces clockwise around the board</li>
          <li>🏠 Get all pieces to the center to win</li>
          <li>⚔️ Land on opponent's piece to send it home</li>
          <li>🔄 Roll 6 to get another turn</li>
        </ul>
      </div>
    </div>
  );
};

export default GameSidebar;
